import { useMemo } from "react";

import { addMonths, startOfMonth } from "date-fns";

import type { EnrollmentGoal } from "api/services/admin/schemas";
import { useLocalizedDate } from "utils/date";

import { NEW_ENROLLMENT_GOAL } from "./utils";

interface UseMonthOptionsArgs {
  data: EnrollmentGoal[];
}

export const useMonthOptions = ({ data }: UseMonthOptionsArgs) => {
  const { format } = useLocalizedDate();

  const monthOptions = useMemo(() => {
    const nextMonthDate = startOfMonth(addMonths(new Date(), 1));
    const nextMonthStr = format(nextMonthDate, "yyyy-MM-dd");
    const hasNextMonth = data.some(item => item.effective_from.slice(0, 10) === nextMonthStr);

    const existingMonths = data.map(item => ({
      label: format(new Date(item.effective_from), "MMMM yyyy"),
      value: item.id,
    }));

    if (!hasNextMonth) {
      existingMonths.push({ label: format(nextMonthDate, "MMMM yyyy"), value: NEW_ENROLLMENT_GOAL });
    }

    return existingMonths;
  }, [data]);

  return { monthOptions };
};
